import {Auth, User} from "@core/model";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

type AuthState = {
  user?: User;
  loading: false;
  autoLogin: boolean;
  accessToken: string | undefined;
};

const initialState: AuthState = {
  user: undefined,
  loading: false,
  autoLogin: localStorage.getItem("rememberMe") === "1",
  accessToken: undefined,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setAuth: (state, action: PayloadAction<Auth>) => {
      const {user, accessToken} = action.payload;
      state.user = user;
      state.accessToken = accessToken;
    },
    logout: state => {
      state.user = undefined;
      state.accessToken = undefined;
      state.autoLogin = false;
      localStorage.setItem("rememberMe", "0");
    },
    setAccessToken: (state, action: PayloadAction<string | undefined>) => {
      state.accessToken = action.payload;
    },
  },
});

export const {setAuth, logout, updateUser, setAccessToken} = authSlice.actions;

export default authSlice.reducer;
